import axios from "axios";
import Cookies from "universal-cookie";
const cookies = new Cookies();

export const createProjectApi = async (
  url: string,
  name: string,
  sequence: number,
  DonationPurposeId: string,
  image: File,
  description: string,
  details: string,
  status: string,
  budget: number,
  adjustment: number,
  priority: number
) => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.post(
      `${url}/project/create`,
      {
        Name: name,
        Sequence: sequence,
        DonationPurposeId: DonationPurposeId,
        Image: image,
        Description: description,
        Details: details,
        Status: status,
        Budget: budget,
        Adjustment: adjustment,
        Priority: priority,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error(error);

    throw error;
  }
};

export const getProjectsApi = async (url: string) => {
  const token = cookies.get("authToken");
  try {
    const response = await axios.get(`${url}/project/get`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error(error);

    return false;
  }
};

export const getProjectByIdApi = async (Id: string, url: string) => {
  const token = cookies.get("authToken");
  try {
    const response = await axios.get(`${url}/project/getbyid`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        Id,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);

    return false;
  }
};

export const updateProjectApi = async (
  url: string,
  id: string,
  name: string,
  sequence: number,
  DonationPurposeId: string,
  image: string | null,
  description: string,
  details: string,
  status: string,
  budget: number,
  adjustment: number,
  priority: number
) => {
  const token = cookies.get("authToken");

  const requestData: any = {
    Id: id,
    Name: name,
    Sequence: sequence,
    DonationPurposeId: DonationPurposeId,
    Description: description,
    Details: details,
    Status: status,
    Budget: budget,
    Adjustment: adjustment,
    Priority: priority,
  };

  if (image) {
    requestData.Image = image;
  }

  try {
    const response = await axios.post(`${url}/project/update`, requestData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteProjectApi = async (id: string, url: string) => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.request({
      method: "DELETE",
      url: `${url}/project/delete`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        id,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getProjectDetailApi = async (Id: string, url: string) => {
  const token = cookies.get("authToken");
  try {
    const response = await axios.get(`${url}/project/getprojectdetails`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        Id,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);

    return false;
  }
};

export const getProjectDescApi = async (url: string) => {
  const token = cookies.get("authToken");
  try {
    const response = await axios.get(`${url}/project/getProjectsdesc`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error(error);
    return false;
  }
};
